import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { createSelector } from 'reselect';
import MultiElementProperties from './MultiElementProperties';

// const currentElementIdSelector = (state, props) => {
//   return props.element.get('id');
// };

// const elementTypeSelector = (state, props) => {
//   const currentElementId = currentElementIdSelector(state, props);

//   const testing = state.elements.getIn(['elements', currentElementId, 'type_id']);
//   const current = testing ? state.elementTypes.getIn(['elementTypes', testing.toString()]) : null;

//   return currentElementId && current ? current : null;
// };

// const inlineEditorSelector = (state, props) => {
//   return state.inlineEditors.get('editors');
// };

// const getElements = (elementIds, elements) => {
//   return elementIds.map(eid => elements.get())
// };

const elementsSelector = (state, props) => {
  const { elementIds } = props;
  return elementIds.map(eid => state.elements.getIn(['elements', eid]));
};

// const elementTypeSelector = (state, props) => {
//   const { elementIds } = props;
//   console.log('aaaa', elementIds)
//   debugger;
//   const elementTypeId = elementIds.get(0).get('type_id');
//   console.log('bbb',elementTypeId)
//   const elementType = state.elementTypes.getIn(['elementTypes', elementTypeId]);

//   return elementType;
// };

const MultiElementPropertiesContainerSelector = createSelector(
  elementsSelector,
  (elements) => {
    return {
      elements,
    };
  }
);

@connect(MultiElementPropertiesContainerSelector)
export default class MultiElementPropertiesContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    element: PropTypes.instanceOf(Map),
  };

  render() {
    if (!this.props.elementIds) {
      return <div />;
    }
    return (<MultiElementProperties {...this.props} />);
  }
}



// WEBPACK FOOTER //
// ./src/components/RightColumn/MultiElementEdit/MultiElementPropertiesContainer.js